// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-BookingDetails-Car-styles___carDetails--iRoFM {
  text-align: left;
  margin-bottom: 32px;
  border: 1px solid #dddee0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___numbers--jl23X {
    padding: 0 16px;
    color: #6d717a;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___numbers--jl23X .components-BookingDetails-Car-styles___highlight--t_ez0 {
      color: #1b2432;
      font-weight: 500;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___carDetailsTitle--q6Haf {
    font-size: 17px;
    color: #1b2432;
    letter-spacing: 0;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___row--HfuH9 {
    padding: 20px 0;
    border-bottom: 1px solid #c6c8cc;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___row--HfuH9.components-BookingDetails-Car-styles___no-border--xxikG {
      border: none;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___row--HfuH9 .components-BookingDetails-Car-styles___baseFare--sDG9_ {
      text-align: right;
      line-height: 22px;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___row--HfuH9 .components-BookingDetails-Car-styles___baseFare--sDG9_ .components-BookingDetails-Car-styles___baseprice--SDPpj {
        font-size: 15px;
        color: #1b2432;
        letter-spacing: 0;
      }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___row--HfuH9 .components-BookingDetails-Car-styles___baseFare--sDG9_ .components-BookingDetails-Car-styles___price--bOMMx {
        font-size: 13px;
        color: #1b2432;
        letter-spacing: 0;
      }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___row--HfuH9 .components-BookingDetails-Car-styles___baseFare--sDG9_ .components-BookingDetails-Car-styles___fees--Dgnk1 {
        font-size: 13px;
        color: #6d717a;
        letter-spacing: 0;
      }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___title--EIgD2 {
    font-size: 15px;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___fees--Dgnk1 {
    font-size: 13px;
    color: #6d717a;
    letter-spacing: 0;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___subtitle--o8T5q {
    font-size: 13px;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___cancelPolicyRow--x8qMN {
    display: flex;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___cancelPolicyRow--x8qMN .components-BookingDetails-Car-styles___cancelPolicy--COVsS {
      flex: 1;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___cancelPolicyRow--x8qMN .components-BookingDetails-Car-styles___cancelPolicy--COVsS .components-BookingDetails-Car-styles___highlight--t_ez0 {
        margin-top: 2px;
      }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___cancelPolicyRow--x8qMN .components-BookingDetails-Car-styles___icon--ujV_t {
      color: #318afb;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___withPrice--xEe0m {
    display: flex;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___withPrice--xEe0m .components-BookingDetails-Car-styles___title--EIgD2,
    .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___withPrice--xEe0m .components-BookingDetails-Car-styles___subtitle--o8T5q {
      flex: 1;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___withPrice--xEe0m .components-BookingDetails-Car-styles___title--EIgD2 svg, .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___withPrice--xEe0m .components-BookingDetails-Car-styles___subtitle--o8T5q svg {
        margin-left: 6px;
        transition: transform 150ms ease;
      }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___withPrice--xEe0m .components-BookingDetails-Car-styles___fees--Dgnk1 {
      font-size: 13px;
      color: #6d717a;
      letter-spacing: 0;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___withPrice--xEe0m .components-BookingDetails-Car-styles___subtitle--o8T5q {
      padding-left: 16px;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___withPrice--xEe0m .components-BookingDetails-Car-styles___price--bOMMx {
      color: #1b2432;
      font-weight: 500;
      font-size: 15px;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___withPrice--xEe0m .components-BookingDetails-Car-styles___price--bOMMx.components-BookingDetails-Car-styles___total--ciBNK {
        font-size: 21px;
        font-weight: 600;
      }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___dropdown--fG1Zi {
    padding-left: 15px;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___rotate--wZf6u svg {
      transform: rotate(180deg);
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___buttonWrapper--PaL4D {
    padding: 16px 0;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___button--yRKbb {
    text-transform: initial;
    padding: 16px;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___warning_container--sd4WM {
    display: flex;
    margin-top: 5px;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___warning_container--sd4WM .components-BookingDetails-Car-styles___warning--vA_Gb {
      flex: 1;
      color: #6d717a;
      font-size: 13px;
      line-height: 17px;
      text-align: left;
      padding-bottom: 16px;
      padding-right: 15px;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___warning_container--sd4WM .components-BookingDetails-Car-styles___warning--vA_Gb span {
        color: #fc3b60 !important;
      }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___warning_container--sd4WM .components-BookingDetails-Car-styles___icon--ujV_t {
      color: #318afb;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___warning_container--sd4WM div svg {
        cursor: pointer;
      }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___warning_container--sd4WM .components-BookingDetails-Car-styles___multiWarning--Tlqby {
      flex: 1;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___terms--I9fRh {
    color: #6d717a;
    font-size: 13px;
    line-height: 17px;
    text-align: center;
    padding-bottom: 16px;
  }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___terms--I9fRh span {
      font-weight: 500;
    }

  .components-BookingDetails-Car-styles___carDetails--iRoFM .components-BookingDetails-Car-styles___terms--I9fRh a {
      color: #318afb;
    }

.components-BookingDetails-Car-styles___totalPrice--U3qxi {
  flex: 1;
  letter-spacing: 0;
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  font-weight: bold;
}

.components-BookingDetails-Car-styles___segmentDetail--RsX_K {
  border: none !important;
  webkit-box-shadow: none !important;
  box-shadow: none !important;
}

.components-BookingDetails-Car-styles___segmentDetail--RsX_K .components-BookingDetails-Car-styles___container--Nxy0b {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 32px 32px 0 32px;
  }

.components-BookingDetails-Car-styles___segmentDetail--RsX_K .components-BookingDetails-Car-styles___container--Nxy0b .components-BookingDetails-Car-styles___destinations--EOPIc {
      font-size: 30px;
      color: #1b2432;
      letter-spacing: 0;
      min-width: 180px;
      align-self: center;
    }

.components-BookingDetails-Car-styles___segmentDetail--RsX_K .components-BookingDetails-Car-styles___container--Nxy0b .components-BookingDetails-Car-styles___destinations--EOPIc svg {
        margin: 0 20px;
      }

.components-BookingDetails-Car-styles___segmentDetail--RsX_K .components-BookingDetails-Car-styles___container--Nxy0b .components-BookingDetails-Car-styles___details--ctG7i {
      font-size: 25px;
      color: #1b2432;
      letter-spacing: 0;
      margin: 0;
    }

.components-BookingDetails-Car-styles___segmentDetail--RsX_K .components-BookingDetails-Car-styles___container--Nxy0b .components-BookingDetails-Car-styles___labels--eBkTl {
      font-size: 11px;
      color: #6d717a;
      letter-spacing: 0;
      margin-bottom: 8px;
      margin-top: 0;
      font-weight: 400;
    }

.components-BookingDetails-Car-styles___segmentDetail--RsX_K .components-BookingDetails-Car-styles___container--Nxy0b .components-BookingDetails-Car-styles___airline--LLlY3 {
      margin-bottom: 0;
    }

.components-BookingDetails-Car-styles___segmentDetail--RsX_K .components-BookingDetails-Car-styles___buttons--nYx8c .components-BookingDetails-Car-styles___button--yRKbb {
      color: #318afb;
      min-width: 74px;
      height: 32px;
    }

.components-BookingDetails-Car-styles___segmentDetail--RsX_K .components-BookingDetails-Car-styles___withBorder--bsaGg {
    border-bottom: 1px solid #dddee0;
  }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu {
  padding: 32px;
  padding-bottom: 0;
  margin-bottom: 32px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
}

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___header--PqBYq {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 1px solid #dddee0;
    padding-bottom: 12px;
    text-align: left;
    align-items: center;
  }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___header--PqBYq .components-BookingDetails-Car-styles___title--EIgD2 {
      font-size: 13px;
      color: #6d717a;
      letter-spacing: 0;
    }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___header--PqBYq .components-BookingDetails-Car-styles___description--_iqHZ {
      font-size: 15px;
      color: #1b2432;
      letter-spacing: 0;
      font-weight: 500;
    }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___header--PqBYq .components-BookingDetails-Car-styles___confNumb--v3qrL {
      font-size: 11px;
      color: #6d717a;
      letter-spacing: 0;
      margin-bottom: 4px;
    }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___header--PqBYq .components-BookingDetails-Car-styles___confNumb--v3qrL + p {
      margin-top: 8px;
    }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___header--PqBYq .components-BookingDetails-Car-styles___carName--y2wKF {
      font-size: 21px;
      color: #1b2432;
      letter-spacing: 0;
      margin: 0;
    }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___header--PqBYq .components-BookingDetails-Car-styles___carName--y2wKF .components-BookingDetails-Car-styles___title--EIgD2 {
        margin-top: 6px;
      }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___header--PqBYq .components-BookingDetails-Car-styles___carName--y2wKF p {
        margin-bottom: 5px;
      }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___carInfo--rvQzz {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #dddee0;
    padding: 12px 0;
    text-align: left;
  }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___carInfo--rvQzz .components-BookingDetails-Car-styles___title--EIgD2 {
      font-size: 13px;
      color: #6d717a;
      letter-spacing: 0;
      margin-bottom: 4px;
    }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___carInfo--rvQzz .components-BookingDetails-Car-styles___description--_iqHZ {
      font-size: 15px;
      color: #1b2432;
      letter-spacing: 0;
      font-weight: 500;
      margin-top: 2px;
      padding-right: 40px;
      font-weight: 600;
    }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___carInfo--rvQzz div {
      min-width: 228px;
    }

.components-BookingDetails-Car-styles___carBookingDetails--jhayu .components-BookingDetails-Car-styles___carInfo--rvQzz:last-child {
      border: none !important;
    }

.components-BookingDetails-Car-styles___cancelInfoIcon--TGozR {
  align-self: center;
  cursor: pointer;
}

.components-BookingDetails-Car-styles___confirmationBodyTextStyle--iJSWt {
  width: 450px;
  padding-left: 32px !important;
  padding-right: 32px !important;
  padding-bottom: 10px !important;
}

.components-BookingDetails-Car-styles___carDetailsRow--ht5G0 {
  display: flex;
  margin-bottom: 6px;
}

.components-BookingDetails-Car-styles___carDetailsRow--ht5G0 p {
    margin-right: 10px;
    font-family: 'Roboto';
    font-size: 15px;
    color: #1b2432;
    letter-spacing: 0;
    line-height: 15px;
    height: 25px;
    padding-left: 5px;
    padding-right: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #edeeef;
    border-radius: 3px;
    font-weight: 700;
  }

.components-BookingDetails-Car-styles___carDetailsRow--ht5G0 p::first-letter {
    text-transform: uppercase;
  }

.components-BookingDetails-Car-styles___class--GDP1T {
  font-family: 'Roboto';
  font-size: 17px;
  color: #1b2432;
  letter-spacing: 0;
  margin-top: 23px;
}

.components-BookingDetails-Car-styles___carDetName--dGi2P {
  font-family: 'Roboto';
  font-size: 15px;
  color: #6d717a;
  letter-spacing: 0;
  margin-bottom: 0 !important;
}

.components-BookingDetails-Car-styles___carImage--vyv4a {
  text-align: center;
  max-width: 238px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 35px;
  margin-bottom: 5px;
}

.components-BookingDetails-Car-styles___carImage--vyv4a img {
    width: 238px;
    height: auto;
  }
`, "",{"version":3,"sources":["webpack://./components/BookingDetails/Car/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;AA6K7C;;EA3KE;IACE,eAAe;IACf,cAAc;EAMhB;;EAJE;MACE,cAAc;MACd,gBAAgB;IAClB;;EAGF;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gCAAgC;EA0BlC;;EAxBE;MACE,YAAY;IACd;;EAEA;MACE,iBAAiB;MACjB,iBAAiB;IAiBnB;;EAfE;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;MACnB;;EACA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;MACnB;;EACA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;MACnB;;EAIJ;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EAaf;;EAXE;MACE,OAAO;IAKT;;EAHE;QACE,eAAe;MACjB;;EAGF;MACE,cAAc;IAChB;;EAGF;IACE,aAAa;EA+Bf;;EA7BE;;MAEE,OAAO;IAKT;;EAJE;QACE,gBAAgB;QAChB,gCAAgC;MAClC;;EAGF;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;EAEA;MACE,kBAAkB;IACpB;;EAEA;MACE,cAAc;MACd,gBAAgB;MAChB,eAAe;IAMjB;;EAJE;QACE,eAAe;QACf,gBAAgB;MAClB;;EAIJ;IACE,kBAAkB;EACpB;;EAGE;MACE,yBAAyB;IAC3B;;EAGF;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,aAAa;IACb,eAAe;EAwBjB;;EAvBE;MACE,OAAO;MACP,cAAc;MACd,eAAe;MACf,iBAAiB;MACjB,gBAAgB;MAChB,oBAAoB;MACpB,mBAAmB;IAIrB;;EAHE;QACE,yBAAyB;MAC3B;;EAEF;MACE,cAAc;IAChB;;EAEE;QACE,eAAe;MACjB;;EAEF;MACE,OAAO;IACT;;EAEF;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;EAStB;;EAPE;MACE,gBAAgB;IAClB;;EAEA;MACE,cAAc;IAChB;;AAIJ;EACE,OAAO;EACP,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAElC,2BAA2B;AAkD7B;;AAhDE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,wBAAwB;EAgC1B;;AA9BE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,kBAAkB;IAKpB;;AAHE;QACE,cAAc;MAChB;;AAGF;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,SAAS;IACX;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;MAClB,aAAa;MACb,gBAAgB;IAClB;;AACA;MACE,gBAAgB;IAClB;;AAIA;MACE,cAAc;MACd,eAAe;MACf,YAAY;IACd;;AAEF;IACE,gCAAgC;EAClC;;AAGF;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAmF7C;;AAjFE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gCAAgC;IAChC,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EAwCrB;;AAtCE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;IAClB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;IACpB;;AAEA;MACE,eAAe;IACjB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,SAAS;IASX;;AAPE;QACE,eAAe;MACjB;;AAEA;QACE,kBAAkB;MACpB;;AAIJ;IACE,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;EA0BlB;;AAxBE;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,kBAAkB;IACpB;;AAEA;MACE,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,gBAAgB;MAChB,eAAe;MACf,mBAAmB;MACnB,gBAAgB;IAClB;;AAEA;MACE,gBAAgB;IAClB;;AAEA;MACE,uBAAuB;IACzB;;AAIJ;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,kBAAkB;AAsBpB;;AArBE;IACE,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;EAClB;;AAEA;IACE,yBAAyB;EAC3B;;AAGF;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AAMpB;;AAJE;IACE,YAAY;IACZ,YAAY;EACd","sourcesContent":[".carDetails {\n  text-align: left;\n  margin-bottom: 32px;\n  border: 1px solid #dddee0;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);\n\n  .numbers {\n    padding: 0 16px;\n    color: #6d717a;\n\n    .highlight {\n      color: #1b2432;\n      font-weight: 500;\n    }\n  }\n\n  .carDetailsTitle {\n    font-size: 17px;\n    color: #1b2432;\n    letter-spacing: 0;\n  }\n\n  .row {\n    padding: 20px 0;\n    border-bottom: 1px solid #c6c8cc;\n\n    &.no-border {\n      border: none;\n    }\n\n    .baseFare {\n      text-align: right;\n      line-height: 22px;\n\n      .baseprice {\n        font-size: 15px;\n        color: #1b2432;\n        letter-spacing: 0;\n      }\n      .price {\n        font-size: 13px;\n        color: #1b2432;\n        letter-spacing: 0;\n      }\n      .fees {\n        font-size: 13px;\n        color: #6d717a;\n        letter-spacing: 0;\n      }\n    }\n  }\n\n  .title {\n    font-size: 15px;\n  }\n\n  .fees {\n    font-size: 13px;\n    color: #6d717a;\n    letter-spacing: 0;\n  }\n\n  .subtitle {\n    font-size: 13px;\n  }\n\n  .cancelPolicyRow {\n    display: flex;\n\n    .cancelPolicy {\n      flex: 1;\n\n      .highlight {\n        margin-top: 2px;\n      }\n    }\n\n    .icon {\n      color: #318afb;\n    }\n  }\n\n  .withPrice {\n    display: flex;\n\n    .title,\n    .subtitle {\n      flex: 1;\n      svg {\n        margin-left: 6px;\n        transition: transform 150ms ease;\n      }\n    }\n\n    .fees {\n      font-size: 13px;\n      color: #6d717a;\n      letter-spacing: 0;\n    }\n\n    .subtitle {\n      padding-left: 16px;\n    }\n\n    .price {\n      color: #1b2432;\n      font-weight: 500;\n      font-size: 15px;\n\n      &.total {\n        font-size: 21px;\n        font-weight: 600;\n      }\n    }\n  }\n\n  .dropdown {\n    padding-left: 15px;\n  }\n\n  .rotate {\n    svg {\n      transform: rotate(180deg);\n    }\n  }\n\n  .buttonWrapper {\n    padding: 16px 0;\n  }\n\n  .button {\n    text-transform: initial;\n    padding: 16px;\n  }\n\n  .warning_container {\n    display: flex;\n    margin-top: 5px;\n    .warning {\n      flex: 1;\n      color: #6d717a;\n      font-size: 13px;\n      line-height: 17px;\n      text-align: left;\n      padding-bottom: 16px;\n      padding-right: 15px;\n      span {\n        color: #fc3b60 !important;\n      }\n    }\n    .icon {\n      color: #318afb;\n    }\n    div {\n      svg {\n        cursor: pointer;\n      }\n    }\n    .multiWarning {\n      flex: 1;\n    }\n  }\n  .terms {\n    color: #6d717a;\n    font-size: 13px;\n    line-height: 17px;\n    text-align: center;\n    padding-bottom: 16px;\n\n    span {\n      font-weight: 500;\n    }\n\n    a {\n      color: #318afb;\n    }\n  }\n}\n\n.totalPrice {\n  flex: 1;\n  letter-spacing: 0;\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  font-weight: bold;\n}\n\n.segmentDetail {\n  border: none !important;\n  webkit-box-shadow: none !important;\n  -moz-box-shadow: none !important;\n  box-shadow: none !important;\n\n  .container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    margin: 32px 32px 0 32px;\n\n    .destinations {\n      font-size: 30px;\n      color: #1b2432;\n      letter-spacing: 0;\n      min-width: 180px;\n      align-self: center;\n\n      svg {\n        margin: 0 20px;\n      }\n    }\n\n    .details {\n      font-size: 25px;\n      color: #1b2432;\n      letter-spacing: 0;\n      margin: 0;\n    }\n\n    .labels {\n      font-size: 11px;\n      color: #6d717a;\n      letter-spacing: 0;\n      margin-bottom: 8px;\n      margin-top: 0;\n      font-weight: 400;\n    }\n    .airline {\n      margin-bottom: 0;\n    }\n  }\n\n  .buttons {\n    .button {\n      color: #318afb;\n      min-width: 74px;\n      height: 32px;\n    }\n  }\n  .withBorder {\n    border-bottom: 1px solid #dddee0;\n  }\n}\n\n.carBookingDetails {\n  padding: 32px;\n  padding-bottom: 0;\n  margin-bottom: 32px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);\n\n  .header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    border-bottom: 1px solid #dddee0;\n    padding-bottom: 12px;\n    text-align: left;\n    align-items: center;\n\n    .title {\n      font-size: 13px;\n      color: #6d717a;\n      letter-spacing: 0;\n    }\n\n    .description {\n      font-size: 15px;\n      color: #1b2432;\n      letter-spacing: 0;\n      font-weight: 500;\n    }\n\n    .confNumb {\n      font-size: 11px;\n      color: #6d717a;\n      letter-spacing: 0;\n      margin-bottom: 4px;\n    }\n\n    .confNumb + p {\n      margin-top: 8px;\n    }\n\n    .carName {\n      font-size: 21px;\n      color: #1b2432;\n      letter-spacing: 0;\n      margin: 0;\n\n      .title {\n        margin-top: 6px;\n      }\n\n      p {\n        margin-bottom: 5px;\n      }\n    }\n  }\n\n  .carInfo {\n    display: flex;\n    flex-direction: row;\n    border-bottom: 1px solid #dddee0;\n    padding: 12px 0;\n    text-align: left;\n\n    .title {\n      font-size: 13px;\n      color: #6d717a;\n      letter-spacing: 0;\n      margin-bottom: 4px;\n    }\n\n    .description {\n      font-size: 15px;\n      color: #1b2432;\n      letter-spacing: 0;\n      font-weight: 500;\n      margin-top: 2px;\n      padding-right: 40px;\n      font-weight: 600;\n    }\n\n    div {\n      min-width: 228px;\n    }\n\n    &:last-child {\n      border: none !important;\n    }\n  }\n}\n\n.cancelInfoIcon {\n  align-self: center;\n  cursor: pointer;\n}\n\n.confirmationBodyTextStyle {\n  width: 450px;\n  padding-left: 32px !important;\n  padding-right: 32px !important;\n  padding-bottom: 10px !important;\n}\n\n.carDetailsRow {\n  display: flex;\n  margin-bottom: 6px;\n  p {\n    margin-right: 10px;\n    font-family: 'Roboto';\n    font-size: 15px;\n    color: #1b2432;\n    letter-spacing: 0;\n    line-height: 15px;\n    height: 25px;\n    padding-left: 5px;\n    padding-right: 5px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #edeeef;\n    border-radius: 3px;\n    font-weight: 700;\n  }\n\n  p::first-letter {\n    text-transform: uppercase;\n  }\n}\n\n.class {\n  font-family: 'Roboto';\n  font-size: 17px;\n  color: #1b2432;\n  letter-spacing: 0;\n  margin-top: 23px;\n}\n\n.carDetName {\n  font-family: 'Roboto';\n  font-size: 15px;\n  color: #6d717a;\n  letter-spacing: 0;\n  margin-bottom: 0 !important;\n}\n\n.carImage {\n  text-align: center;\n  max-width: 238px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 35px;\n  margin-bottom: 5px;\n\n  img {\n    width: 238px;\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carDetails": `components-BookingDetails-Car-styles___carDetails--iRoFM`,
	"numbers": `components-BookingDetails-Car-styles___numbers--jl23X`,
	"highlight": `components-BookingDetails-Car-styles___highlight--t_ez0`,
	"carDetailsTitle": `components-BookingDetails-Car-styles___carDetailsTitle--q6Haf`,
	"row": `components-BookingDetails-Car-styles___row--HfuH9`,
	"noBorder": `components-BookingDetails-Car-styles___no-border--xxikG`,
	"baseFare": `components-BookingDetails-Car-styles___baseFare--sDG9_`,
	"baseprice": `components-BookingDetails-Car-styles___baseprice--SDPpj`,
	"price": `components-BookingDetails-Car-styles___price--bOMMx`,
	"fees": `components-BookingDetails-Car-styles___fees--Dgnk1`,
	"title": `components-BookingDetails-Car-styles___title--EIgD2`,
	"subtitle": `components-BookingDetails-Car-styles___subtitle--o8T5q`,
	"cancelPolicyRow": `components-BookingDetails-Car-styles___cancelPolicyRow--x8qMN`,
	"cancelPolicy": `components-BookingDetails-Car-styles___cancelPolicy--COVsS`,
	"icon": `components-BookingDetails-Car-styles___icon--ujV_t`,
	"withPrice": `components-BookingDetails-Car-styles___withPrice--xEe0m`,
	"total": `components-BookingDetails-Car-styles___total--ciBNK`,
	"dropdown": `components-BookingDetails-Car-styles___dropdown--fG1Zi`,
	"rotate": `components-BookingDetails-Car-styles___rotate--wZf6u`,
	"buttonWrapper": `components-BookingDetails-Car-styles___buttonWrapper--PaL4D`,
	"button": `components-BookingDetails-Car-styles___button--yRKbb`,
	"warningContainer": `components-BookingDetails-Car-styles___warning_container--sd4WM`,
	"warning": `components-BookingDetails-Car-styles___warning--vA_Gb`,
	"multiWarning": `components-BookingDetails-Car-styles___multiWarning--Tlqby`,
	"terms": `components-BookingDetails-Car-styles___terms--I9fRh`,
	"totalPrice": `components-BookingDetails-Car-styles___totalPrice--U3qxi`,
	"segmentDetail": `components-BookingDetails-Car-styles___segmentDetail--RsX_K`,
	"container": `components-BookingDetails-Car-styles___container--Nxy0b`,
	"destinations": `components-BookingDetails-Car-styles___destinations--EOPIc`,
	"details": `components-BookingDetails-Car-styles___details--ctG7i`,
	"labels": `components-BookingDetails-Car-styles___labels--eBkTl`,
	"airline": `components-BookingDetails-Car-styles___airline--LLlY3`,
	"buttons": `components-BookingDetails-Car-styles___buttons--nYx8c`,
	"withBorder": `components-BookingDetails-Car-styles___withBorder--bsaGg`,
	"carBookingDetails": `components-BookingDetails-Car-styles___carBookingDetails--jhayu`,
	"header": `components-BookingDetails-Car-styles___header--PqBYq`,
	"description": `components-BookingDetails-Car-styles___description--_iqHZ`,
	"confNumb": `components-BookingDetails-Car-styles___confNumb--v3qrL`,
	"carName": `components-BookingDetails-Car-styles___carName--y2wKF`,
	"carInfo": `components-BookingDetails-Car-styles___carInfo--rvQzz`,
	"cancelInfoIcon": `components-BookingDetails-Car-styles___cancelInfoIcon--TGozR`,
	"confirmationBodyTextStyle": `components-BookingDetails-Car-styles___confirmationBodyTextStyle--iJSWt`,
	"carDetailsRow": `components-BookingDetails-Car-styles___carDetailsRow--ht5G0`,
	"class": `components-BookingDetails-Car-styles___class--GDP1T`,
	"carDetName": `components-BookingDetails-Car-styles___carDetName--dGi2P`,
	"carImage": `components-BookingDetails-Car-styles___carImage--vyv4a`
};
module.exports = ___CSS_LOADER_EXPORT___;
